module.exports = __webpack_public_path__ + "files/8cf40c2d26934386adcbb7de632809d2.png";